import {
  AirFilterTabsFilter, AirFilterTabsResponse, AirportsResponse, CheckboxFilter,
  CheckboxFilterVm, FilterSorter, FilterSorterCriterias, PriceFilter, PriceRangeFilter, RangeFilterVm, RangeResponseFilter
} from '@shared/filters/entities/fetch-filters.response';
import { HotelFilterInputTypes, HotelFilterTypes } from '@shared/hotel-itinerary/hotel-filters';
import { FilterTypes, AirportFilter } from '@shared/flight-itinerary/entities/filters';

export type HotelFiltersResponse = Readonly<{
  Ammenities: CheckboxFilter[];
  Boards: CheckboxFilter[];
  Category: CheckboxFilter[];
  HighlightedAmmenities: CheckboxFilter[];
  HotelNames: string[];
  HotelPriceRanges: PriceRangeFilter[];
  MaxPrice: number;
  MinPrice: number;
  NonRefundable: CheckboxFilter[];
  PromotionalRates: PriceRangeFilter[];
  PropertyTypes: CheckboxFilter[];
  Results: number;
  Tags: ProductTags[];
  Zones: CheckboxFilter[];
  Sorters: FilterSorter[];
  CheckinTimes: CheckboxFilter[];
  Score: CheckboxFilter[];
}>;

export type AirFiltersResponse = Readonly<{
  Airlines: CheckboxFilter[];
  DepartureTimes: RangeResponseFilter[];
  FlightDurations: RangeResponseFilter[];
  BusClass: CheckboxFilter[];
  ArrivalAirports: AirportsResponse[];
  DepartureAirports: AirportsResponse[];
  Alliances: CheckboxFilter[];
  Stops: CheckboxFilter[];
  AirPriceRanges: PriceRangeFilter[];
  MinPrice: number;
  MaxPrice: number;
  Results: number;
  AirFilterTabs: AirFilterTabsResponse[];
  Tags?: ProductTags[];
  Baggages?: ProductBaggage[];
}>;

export type AirFilterResponseVm = Readonly<{
  Airlines: CheckboxFilterVm[];
  AirlinesMinPrice: CheckboxFilterVm[];
  DepartureTimes: RangeFilterVm[];
  SectorDurations: RangeFilterVm[];
  BusClass: CheckboxFilterVm[];
  ArrivalAirports: AirportsResponse[];
  DepartureAirports: AirportsResponse[];
  Alliances: CheckboxFilterVm[];
  Stops: CheckboxFilterVm[];
  AirPriceRanges: AirPriceRangeFilterVm[];
  PriceRange?: RangeFilterVm;
  AirFilterTabs: AirFilterTabsResponse[];
  Tags?: ProductTags[];
}>;

export type HotelFilterVm = Readonly<{
  type: HotelFilterTypes;
  filter?: HotelFilterInputTypes;
  value: ValuesOfHotelFiltersVm;
  order?: number;
}>;

export type AirFilterVm = Readonly<{
  type: FilterTypes;
  filter: AirFilterInputTypes | undefined;
  value: AirValueFilterVm;
  order?: number;
}>;

export type AirPriceRangeFilterVm = Readonly<{
  Text: string;
  Label: string;
  Count: number
}>;

export type ProductTags = Readonly<{
  Text: string;
  Count: number
}>;

export type ProductBaggage = Readonly<{
  Text: string,
  Count: number,
}>;

export enum AirFilterInputTypes {
  Checkbox = 'checkbox',
  SectorCheckbox = 'sector_checkbox',
  Range = 'range',
  Radio = 'radio',
  Input = 'input'
}

export const AirFilterInputType = {
  [FilterTypes.Stops]: AirFilterInputTypes.Checkbox,
  [FilterTypes.Airlines]: AirFilterInputTypes.Checkbox,
  [FilterTypes.PriceRange]: AirFilterInputTypes.Range,
  [FilterTypes.Alliances]: AirFilterInputTypes.Checkbox,
  [FilterTypes.AirPriceRanges]: AirFilterInputTypes.Range,
  [FilterTypes.BusClass]: AirFilterInputTypes.Checkbox,
  [FilterTypes.DepartureAirports]: AirFilterInputTypes.SectorCheckbox,
  [FilterTypes.ArrivalAirports]: AirFilterInputTypes.SectorCheckbox,
  [FilterTypes.SectorDurations]: AirFilterInputTypes.Range,
  [FilterTypes.DepartureTimes]: AirFilterInputTypes.Range,
  [FilterTypes.Tags]: AirFilterInputTypes.Checkbox,
};

export type AirValueFilterVm = RangeResponseFilter | CollectionByAirlFiltersVm[];

export type ValuesOfHotelFiltersVm = CollectionByHotelFiltersVm[] | string | PriceFilter | boolean | FilterSorter[];

export type CollectionByAirlFiltersVm = RangeResponseFilter | CheckboxFilterVm | PriceRangeFilter | AirFilterTabsFilter |
  AirportFilter | FilterSorterCriterias;
  
type CollectionByHotelFiltersVm = string | CheckboxFilter | PriceRangeFilter;

